import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 0 50px 50px 50px;
    background: #000;

    @media (max-width: 1650px) {
        padding: 0 30px 50px 30px;
    }
`

export const Lista = styled.ul`
    float: left;
    width: 100%;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;

    @media (max-width: 1700px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ItemLista = styled.li`
    list-style: none;
`

export const BoxTags = styled.div`
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ItemTagDesconto = styled.span`
    color: #A36B00;
    font-weight: 600;
    text-align: center;
    border: solid 1px #A36B00;
    padding: 0 11px;
    border-radius: 26px;
    font-size: 12px;
    height: 30px;
    display: flex;
    align-items: center;
`

export const ItemTagMaisVendida = styled.span`
    color: #fff;
    font-weight: bold;
    text-align: center;
    background: #F09C00;
    border-radius: 26px;
    font-size: 12px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 11px;
    margin-left: 10px;
`

export const ItemTitulo = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    text-align: center;
    font-weight: 700;
    margin: 15px 0 10px 0;
    font-size: 20px;
`

export const ItemListaBonus = styled.ol`
    float: left;
    width: 100%;
    margin: 0 0 20px 0;
    padding: 0;
    min-height: 20px;
`

export const ItemListaBonusItem = styled.li`
    color: #CBD4E1;
    list-style: none;
    text-align: center;
    font-size: 12px;
    line-height: 18px;
`

export const ItemListaBoxPrecos = styled.div`
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
`

export const ItemListaBoxPrecosItem = styled.div`
    border-radius: 8px;
    background-color: #475569;
    padding: 15px 10px 10px 10px;
`

export const ItemListaBoxPrecosItemTitulo = styled.span`
    float: left;
    text-align: left;
    color: #fff;
    margin-bottom: 10px;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
`

export const ItemListaBoxPrecosItemDescricao = styled.span`
    float: left;
    text-align: left;
    color: #fff;
    margin-bottom: 10px;
    width: 100%;
    font-size: 12px;
    height: 35px;
`

export const ItemListaBoxPrecosItemPrecoDe = styled.span`
    float: left;
    text-align: left;
    color: #E2E8F0;
    width: 100%;
    font-size: 11px;
    line-height: 24px;

    ::first-letter {
        text-transform: capitalize;
    }
`

export const ItemListaBoxPrecosItemPrecoPor = styled.span`
    float: left;
    text-align: left;
    color: #fff;
    margin-bottom: 10px;
    width: 100%;
    font-size: 16px;
    letter-spacing: -0.5px;
    font-weight: bold;
`

export const ItemListaBoxPrecosItemLink = styled.a`
    display: inline-block;
    background: #C98400;
    width: 100%;
    color: #fff;
    padding: 8px 10px;
    border-radius: 4px;
    font-weight: 600;
    text-decoration: none;
    font-size: 13px;
    text-align: center;
`